const HUBSPOT_WIDGET_ID = 'hubspot-messages-iframe-container';

export const hideHubSpotWidget = () => {
  const hubspotElement = document.getElementById(HUBSPOT_WIDGET_ID);
  if (hubspotElement) {
    hubspotElement.style.setProperty('display', 'none', 'important');
  }
};

export const showHubSpotWidget = () => {
  const hubspotElement = document.getElementById(HUBSPOT_WIDGET_ID);
  if (hubspotElement) {
    hubspotElement.style.setProperty('display', 'initial', 'important');
  }
};

export const isHubSpotWidgetHidden = () => {
  const hubspotElement = document.getElementById(HUBSPOT_WIDGET_ID);
  if (hubspotElement) {
    const display = hubspotElement.style.getPropertyValue('display');
    return display === 'none';
  }
  return true;
};

export const openHubSpotWidgetChat = () => {
  window?.HubSpotConversations?.widget?.open();
};

export const closeHubSpotWidgetChat = () => {
  window?.HubSpotConversations?.widget?.close();
};

type SetHubSpotWidgetPositionProps = {
  bottom: string;
};

export const setHubSpotWidgetPosition = ({ bottom }: SetHubSpotWidgetPositionProps) => {
  const hubspotElement = document.getElementById(HUBSPOT_WIDGET_ID);
  if (hubspotElement) {
    hubspotElement.style.setProperty('bottom', bottom, 'important');
  }
};
